module.exports = __webpack_public_path__ + "static/media/2.ffeeef4d.jpg";